import { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import Firebase from "./components/Firebase";
import { GlobalProvider, FunctionsProvider } from "./components/common/Context";
import reportWebVitals from "./reportWebVitals";
import LoadingModal from "./components/common/LoadingModal";

const fsvc = Firebase();

fsvc.getFirebase().then(() => {
  ReactDOM.render(
    <Suspense fallback={<LoadingModal width={6} />}>
      <GlobalProvider fsvc={fsvc}>
        <FunctionsProvider>
          <App />
        </FunctionsProvider>
      </GlobalProvider>
    </Suspense>,
    document.getElementById("root")
  );
});
reportWebVitals();
